import React, { useState } from 'react';
import Brokoli from '../../../assets/images/brokoli.png';
import SawiHijau from '../../../assets/images/sayur/daun/sawi-hijau.jpeg';
import Wortel from '../../../assets/images/sayur/akar/wortel.jpeg';
import Kecambah from '../../../assets/images/sayur/akar/kecambah.jpeg';
import PaprikaMerah from '../../../assets/images/sayur/buah/paprika-merah.jpeg';
import JagungManis from '../../../assets/images/sayur/buah/jagung.jpeg';
import Kentang from '../../../assets/images/sayur/umbi/kentang.jpeg';
import Bayam from '../../../assets/images/sayur/daun/bayam.jpeg';
import Selada from '../../../assets/images/sayur/daun/selada.jpeg';
import TerongUngu from '../../../assets/images/sayur/buah/terong-ungu.jpeg';
import ProductItem from '../../../components/Category/ProductItem';

const Fruit = ({
  SayurDaun = [
    {
      nameProduct: 'Sawi Hijau',
      imageProduct: SawiHijau,
      weight: '1 ikat',
      priceBefore: '3.0000',
      priceAfter: '2.000',
    },
    {
      nameProduct: 'Kecambah',
      imageProduct: Kecambah,
      weight: '1 ikat',
      priceBefore: '',
      priceAfter: '5.000',
    },
    {
      nameProduct: 'Paprika Merah',
      imageProduct: PaprikaMerah,
      weight: '100 gram',
      priceBefore: '6000',
      priceAfter: '2.000',
    },
    {
      nameProduct: 'Bayam',
      imageProduct: Bayam,
      weight: '1 ikat',
      priceBefore: '10.000',
      priceAfter: '4.000',
    },
    {
      nameProduct: 'Selada',
      imageProduct: Selada,
      weight: '1 ikat',
      priceBefore: '4000',
      priceAfter: '2.000',
    },
    {
      nameProduct: 'Wortel',
      imageProduct: Wortel,
      weight: '1 ikat',
      priceBefore: '6000',
      priceAfter: '3.000',
    },
    {
      nameProduct: 'Terong Ungu',
      imageProduct: TerongUngu,
      weight: '1 kg',
      priceBefore: '8000',
      priceAfter: '5.000',
    },
  ],
  SayurAkar = [
    {
      nameProduct: 'Sawi',
      imageProduct: SawiHijau,
      weight: '1 ikat',
      priceBefore: '3.0000',
      priceAfter: '2.000',
    },
    {
      nameProduct: 'Bayam',
      imageProduct: Kecambah,
      weight: '1 ikat',
      priceBefore: '',
      priceAfter: '5.000',
    },
    {
      nameProduct: 'Selada',
      imageProduct: PaprikaMerah,
      weight: '100 gram',
      priceBefore: '6000',
      priceAfter: '2.000',
    },
    {
      nameProduct: 'Sawi Putih',
      imageProduct: Bayam,
      weight: '1 ikat',
      priceBefore: '10.000',
      priceAfter: '4.000',
    },
  ],
  SayurBunga = [
    {
      nameProduct: 'Brokoli Hijau',
      imageProduct: SawiHijau,
      weight: '1 ikat',
      priceBefore: '3.0000',
      priceAfter: '2.000',
    },
    {
      nameProduct: 'Brokoli Merah',
      imageProduct: Kecambah,
      weight: '1 ikat',
      priceBefore: '',
      priceAfter: '5.000',
    },
    {
      nameProduct: 'Brokoli Akar',
      imageProduct: PaprikaMerah,
      weight: '100 gram',
      priceBefore: '6000',
      priceAfter: '2.000',
    },
    {
      nameProduct: 'Sawi Putih',
      imageProduct: Bayam,
      weight: '1 ikat',
      priceBefore: '10.000',
      priceAfter: '4.000',
    },
  ],

  SayurBuah = [
    {
      nameProduct: 'Jagung Manis',
      imageProduct: JagungManis,
      weight: '1 ikat',
      priceBefore: '3.0000',
      priceAfter: '2.000',
    },
    {
      nameProduct: 'Brokoli',
      imageProduct: Brokoli,
      weight: '1 ikat',
      priceBefore: '',
      priceAfter: '5.000',
    },
    {
      nameProduct: 'Selada',
      imageProduct: PaprikaMerah,
      weight: '100 gram',
      priceBefore: '6000',
      priceAfter: '2.000',
    },
    {
      nameProduct: 'Sawi Putih',
      imageProduct: Bayam,
      weight: '1 ikat',
      priceBefore: '10.000',
      priceAfter: '4.000',
    },
  ],
  SayurUmbi = [
    {
      nameProduct: 'Kentang',
      imageProduct: Kentang,
      weight: '1 ikat',
      priceBefore: '3.0000',
      priceAfter: '2.000',
    },
    {
      nameProduct: 'Bayam',
      imageProduct: Kecambah,
      weight: '1 ikat',
      priceBefore: '',
      priceAfter: '5.000',
    },
    {
      nameProduct: 'Selada',
      imageProduct: PaprikaMerah,
      weight: '100 gram',
      priceBefore: '6000',
      priceAfter: '2.000',
    },
    {
      nameProduct: 'Sawi Putih',
      imageProduct: Bayam,
      weight: '1 ikat',
      priceBefore: '10.000',
      priceAfter: '4.000',
    },
  ],
  CategorySayur = [
    {
      nameCategory: 'Sayur Daun',
      imgCategory: SawiHijau,
      categoryList: SayurDaun,
    },
    {
      nameCategory: 'Sayur Akar',
      imgCategory: Wortel,
      categoryList: SayurAkar,
    },
    {
      nameCategory: 'Sayur Bunga',
      imgCategory: Kecambah,
      categoryList: SayurBunga,
    },
  ],
}) => {
  const [filterCategory, setFilterCategory] = useState(SayurDaun);
  const [listCategory] = useState(CategorySayur);
  return (
    <>
      <h1 className="text-font-gray text-3xl font-semibold">Buah</h1>
      <div className="flex py-2 flex-wrap">
        {/* Item Category */}
        {listCategory.map((listCategorys, index) => (
          <div
            className={
              'bg-white rounded-lg shadow-xl mx-2 my-3 px-2 py-1 border  cursor-pointer' +
              (filterCategory === listCategorys.categoryList
                ? ' border-basic-orange '
                : ' border-transparent hover:border-basic-orange')
            }
            onClick={() => {
              setFilterCategory(listCategorys.categoryList);
            }}
            key={index}
          >
            <div className="flex items-start justify-center">
              <p className="flex text-sm w-5/12">
                {listCategorys.nameCategory}
              </p>
              <div className="flex justify-center items-center">
                <img src={listCategorys.imgCategory} className="h-12" alt="" />
              </div>
            </div>
          </div>
        ))}

        {/* End Item Category */}
      </div>

      {/* List Category Item  */}
      <div className="flex flex-wrap w-full -mx-2">
        {/* Start Item */}
        {filterCategory === null ? (
          <div> Error </div>
        ) : (
          <ProductItem productItems={filterCategory} />
        )}
        {/* End Item */}
        {/* End Flash Item */}
      </div>
    </>
  );
};

export default Fruit;
